import { useMemo } from 'react'
import { useToursCountryStore } from '../stores/tours-country.store'

/** País base de la operación cuando el usuario no eligió país en el catálogo. */
export const DEFAULT_VIEWER_COUNTRY = 'SV'

/**
 * País del catálogo de Tours (ISO 3166-1 alpha-2).
 *
 * Antes se derivaba de la región del dispositivo, pero la región no es
 * confiable: un teléfono configurado en Estados Unidos mostraba el catálogo
 * de El Salvador vacío. Ahora el país lo elige el usuario en la pantalla de
 * Tours y se persiste en MMKV; acá solo se lee. El default es SV.
 */
export function useViewerCountry(): string {
  const country = useToursCountryStore((s) => s.country)
  return useMemo(() => country || DEFAULT_VIEWER_COUNTRY, [country])
}
